import { ReactNode } from 'react';
import {
  DEFAULT_HEADING_COLOR,
  TEXT_ALIGNMENT,
  HEADING_VARIANT,
  THEME_COLOR,
} from '../../../theme/v2/text';
import { TextAlignment, HeadingVariant } from '../../../types/v2/text';
import { ThemeColors } from '../../../types/v2/theme';
import { renderNode } from '../../../utils/react.utils';

type TextProps = {
  variant?: HeadingVariant;
  align?: TextAlignment;
  color?: ThemeColors;
  casing?: 'uppercase';
} & (
  | { children: ReactNode; text?: never }
  | { children?: never; text: string }
);

export default function Heading(props: TextProps) {
  const { children, text, variant, align, color, casing } = props;

  // render the child
  const node = renderNode(children, text);

  // generate the styles
  const headingColor = color
    ? THEME_COLOR[color || 'base']
    : DEFAULT_HEADING_COLOR[variant || 'primary'];

  const headingAlignment = TEXT_ALIGNMENT[align || 'left'];
  const headingVariant = HEADING_VARIANT[variant || 'primary'];

  // concatenate the styles
  const style = `font-text ${headingAlignment} ${headingVariant} ${headingColor} ${
    casing || 'capitalize'
  }`;

  return (
    <>
      {(!variant || variant === 'primary') && <h1 className={style}>{node}</h1>}
      {variant === 'secondary' && <h2 className={style}>{node}</h2>}
      {variant === 'tertiary' && <h3 className={style}>{node}</h3>}
    </>
  );
}
